export default __webpack_public_path__ + "static/media/tracker.18da77d9.svg";